import request from '@/utils/request'

export function validateMember(query) {
  return request({
    url: '/order/service/validate',
    method: 'get',
    params: query
  })
}

export function fetchGoods(query) {
  return request({
    url: '/order/service/goods',
    method: 'get',
    params: query
  })
}

export function createOrder(data) {
  return request({
    url: '/order/service/create',
    method: 'post',
    data
  })
}
